<template>
  <div @click="focus = true" :class="{'term-wrapper': true, 'maximized': maximized, 'untouched': (!dragging && !resizing), 'focused': focus, 'minimized': minimized}" :style="`top:${y}px;left:${x}px;width:${width}px;height:${height}px`">
    <div class="term-header" @mousedown.stop="dragging = true" @mouseup="dragging = false" :style="`cursor: ${dragging ? 'grab' : ''}`">
      <div></div>
      <div class="term-header-user" v-if="meme === undefined">user - {{ user }}</div>
      <div class="term-header-user" v-else>viewing - {{ meme }}</div>
      <div class="term-header-button-wrapper">
        <div class="term-header-button term-min" @click="minimize()"></div>
        <div class="term-header-button term-max" @click="maximize()"></div>
        <div class="term-header-button term-close" @click="close()"></div>
      </div>
    </div>
    <div class="term-body" v-if="meme === undefined">
      <div class="term-line" v-for="(line, i) in term" :key="i" v-html="line.content">
      </div>
      <div class="term-line term-input">
        <span>{{ dir }}></span><span class="term-input">
          <span :class="{'input-char': true, 'input-highlight': index === inputIndex}" v-for="(char, index) in input" :key="index">{{ char }}</span>
        </span><span class="term-cursor" v-if="inputIndex === -1">_</span>
      </div>
    </div>
    <div class="term-body" v-else>
      <img class="meme" :src="require(`@/assets/memes/${meme}.jpg`)" height="98%" />
    </div>
    <div class="term-resize" @mousedown="resizing = true" @mouseup="resizing = false">

    </div>
  </div>
</template>

<script>
import * as commands from '../natos/commands'
import fs from '../natos/fs'

export default {
  name: 'terminal',
  props: ['id', 'meme'],
  data () {
    return {
      dragging: false,
      resizing: false,
      x: 200,
      y: 200,
      width: 500,
      height: 300,
      user: 'anonymous',
      maximized: false,
      minimized: false,
      focus: true,
      term: [{content: 'natos [version 11.8.02]'}, {content: 'type "help" for help'}, {content: '', break: true}],
      input: '',
      inputIndex: -1,
      history: [],
      historyIndex: -1,
      dir: 'root/'
    }
  },
  methods: {
    drag (x, y) {
      if (!this.dragging || this.maximized) return
      this.x += x
      this.y += y
      this.focus = true
    },
    resize (x, y) {
      if (!this.resizing || this.maximized) return
      this.width += x
      this.height += y
      this.focus = true
    },
    minimize () {
      this.minimized = true
    },
    maximize () {
      this.maximized = !this.maximized
    },
    close () {
      this.$parent.killTerminal(this.id)
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    addLine (line) {
      if (typeof line === 'string') line = {content: line}

      this.term.push(line)
      const self = this
      setTimeout(function () {
        self.$el.querySelector('.term-body').scrollTop = self.$el.querySelector('.term-body').scrollHeight
      }, 1)
    },
    handleInput (e) {
      this.$el.querySelector('.term-body').scrollTop = this.$el.querySelector('.term-body').scrollHeight
      if (e.key.length === 1) {
        if (this.inputIndex >= 0) this.input = this.input.slice(0, this.inputIndex - 1) + e.key + this.input.slice(this.inputIndex - 1)
        else this.input += e.key
      }

      switch (e.key) {
        case 'Backspace':
          if (this.inputIndex > 0) this.input = this.input.slice(0, this.inputIndex - 1) + this.input.slice(this.inputIndex--)
          else if (this.inputIndex === -1) this.input = this.input.substring(0, this.input.length - 1)
          break
        case 'ArrowLeft':
          if (this.inputIndex === -1 && this.input.length > 0) this.inputIndex = this.input.length
          if (this.inputIndex > 0) this.inputIndex--
          break
        case 'ArrowRight':
          if (this.inputIndex === -1) return
          if (this.inputIndex < this.input.length) this.inputIndex++
          if (this.inputIndex >= this.input.length) this.inputIndex = -1
          break
        case 'ArrowUp':
          if (this.historyIndex === -1) this.historyIndex = this.history.length - 1
          else this.historyIndex--
          if (this.historyIndex < 0) this.historyIndex = 0
          this.input = this.history[this.historyIndex]
          this.inputIndex = -1
          break
        case 'ArrowDown':
          if (this.historyIndex === -1) {
            this.input = ''
          } else if (++this.historyIndex > this.history.length - 1) {
            this.historyIndex = -1
            this.input = ''
          } else if (this.historyIndex === -1) {
            this.input = ''
          } else this.input = this.history[this.historyIndex]
          this.inputIndex = -1
          break
        case 'Enter':
          this.handleCommand()
          this.historyIndex = -1
          break
      }
    },
    handleCommand () {
      const input = this.input

      if (this.history.slice(-1)[0] !== input) this.history.push(input)
      this.input = ''
      this.inputIndex = -1

      let line = {content: this.dir + '>' + input}
      this.addLine(line)

      let items = input.split(' ')
      items.forEach(item => {
        item = item.toString()
      })

      const cmd = items[0].toLowerCase()
      items = items.slice(1, items.length)

      let args = []
      let flags = []

      items.forEach(item => {
        item = item.toString()
        if (item.includes('-')) flags.push(item)
        else args.push(item)
      })

      this.executeCommand(cmd, args, flags)
    },
    executeCommand (cmd, args, flags) {
      let line
      try {
        line = commands[cmd](this, args, flags)
      } catch (err) {
        console.log(err)
        line = 'command not recognized'
      }
      this.addLine(line)
    },
    getWD () {
      const wd = this.dir
      const path = wd.split('/').filter(item => item !== '')
      let folder = fs()

      path.forEach(dir => {
        folder = folder[dir].contents
      })

      return folder
    },
    imgUrl () {
      // return new URL(`../assets/memes/${this.meme}.jpg`, import.meta.url)
    }
  },
  mounted () {
    document.addEventListener('mousemove', e => {
      const dx = e.movementX
      const dy = e.movementY
      this.drag(dx, dy)
      this.resize(dx, dy)
    })

    document.addEventListener('mousedown', e => {
      const hasFocus = this.$el.contains(e.target)
      this.focus = hasFocus
    })

    document.addEventListener('keydown', e => {
      if (!this.focus) return
      e.preventDefault()
      this.handleInput(e)
    })

    if (this.$route.query.meme) {
      this.maximized = true
    }
  }
}
</script>

<style scoped>
.term-wrapper {
  --bg-color: rgba(14,13,20,1);
  --accent-color: rgba(171,50,52,1);
  --header-height: 25px;
  position: fixed;
  resize: both;
  padding: 0px;
  margin: 0px;
  filter: brightness(75%);
}

.untouched {
  transition: all .3s;
}

.maximized {
  transition: all .3s;
  top: 0px !important;
  left: 0px !important;
  width: 100vw !important;
  height: 100vh !important;
}

.minimized {
  width: 0px !important;
  height: 0px !important;
  left: 750px !important;
  top: 540px !important;
  overflow: hidden !important;
  opacity: 0 !important;
  transform-origin: center;
}

.focused {
  z-index: 3;
  filter: brightness(100%);
}

.term-header {
  width: 100%;
  height: var(--header-height);
  background-color: var(--bg-color);
  opacity: 1;
  filter: brightness(80%);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
}

.term-header-user {
  color: var(--accent-color);
  filter: brightness(75%);
  user-select: none;
}

.term-header-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.term-header-button {
  width: 15px;
  height: 15px;
  background-color: black;
  border-radius: 100%;
  margin-left: 5px;
  filter: brightness(50%);
  transition: filter .2s;
}

.term-header-button:hover {
  filter: brightness(80%);
  cursor: default;
}

.term-header-button:last-child {
  margin-right: 5px;
}

.term-min, .term-max {
  background-color: aqua;
}

.term-close {
  background-color: crimson;
}

.term-body {
  background-color: var(--bg-color);
  filter: brightness(150%);
  width: 100%;
  height: calc(100% - var(--header-height));
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow-y: auto;
}

.term-line {
  padding-left: 5px;
  color: var(--accent-color);
  filter: brightness(75%);
  font-family: monospace;
}

.term-cursor {
  animation: blink 1.5s linear 0s forwards;
  animation-iteration-count: infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  49% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.input-highlight {
  background-color: var(--accent-color);
  color: var(--bg-color);
}

.term-input {
  margin: 0px !important;
}

.term-resize {
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0px;
  bottom: 0px;
  background-color: var(--bg-color);
  opacity: 0;
}

.term-resize:hover {
  cursor: nwse-resize;
}

.help-table {
  table-layout: fixed;
  width: 100%;
}

.help-table td:first-child {
  width: 30%;
}

.help-table td:last-child {
  width: 70%;
}

.help-table td {
  padding: 0px;
  margin: 0px;
  border-right: 0px;
  vertical-align: top;
}

.fs-folder {
  color: aqua;
}

.fs-txt {
  color: bisque;
}

.meme {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/terminal.vue